/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partnersedit1Inputs */

const en_partnersedit1 = /** @type {(inputs: Partnersedit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Edit`)
};

const de_partnersedit1 = /** @type {(inputs: Partnersedit1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bearbeiten`)
};

/**
* | output |
* | --- |
* | "Edit" |
*
* @param {Partnersedit1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const partnersedit1 = /** @type {((inputs?: Partnersedit1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partnersedit1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_partnersedit1(inputs)
	return de_partnersedit1(inputs)
});
export { partnersedit1 as "partnersEdit" }